<template>
	<div :class="$style.notification">
		<BaseTooltip
			v-if="notification.date"
			position="right"
			:content="date"
		>
			<TimeAgo
				:class="[$style['color'], $style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{ $t(`notifications.types.bulk-label-export.${notification.operationType}.title`) }}
		</p>
		<p
			v-if="notification?.totalOperations > 1"
			:class="$style['notification__notice']"
		>
			{{ $t('notifications.types.bulk-label-export.finished-updating') }}: <strong :class="$style['color--success']">{{ notification.totalOperations }}</strong>
		</p>
		<div
			v-if="notification.hasLink"
			:class="$style['notification__buttons']"
		>
			<button
				:class="$style['notification__button']"
				@click="handleDownload"
			>
				<BaseRipple />
				{{ $t('common.actions.download') }}
			</button>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'

export default {
	name: 'BulkLabelExportNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	computed: {
		date () {
			if (this.notification.date) {
				return moment(this.notification.date).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.date) {
				return new Date(this.notification.date).getTime()
			}
			return null
		}
	},
	methods: {
		async handleDownload () {
			const { data } = await this.$apollo.mutate({
				mutation: gql`
					query NotificationLinkPresignedUrl ($payload: NotificationLinkPresignedUrlInput!){
						notificationLinkPresignedUrl (payload: $payload) {
							url
						}
					}
				`,
				variables: {
					payload: {
						resourceId: this.$auth().id,
						notificationType: this.notification.type,
						notificationReceiverType: this.notification.receiverType,
						notificationId: this.notification.id
					}
				}
			})
			try {
				if (!data || !data.notificationLinkPresignedUrl.url) {
					throw new Error()
				}
				if (data.errors) {
					throw data.errors
				}
				window.open(data.notificationLinkPresignedUrl.url)
			} catch (error) {
				this.$store.dispatch('Notification/ADD_ERROR_NOTIFICATION', error)
			}
		}
	}
}
</script>

<style lang="scss" module>
	.color {
		font-size: 12px;

		&--grey {
			color: grey;
		}

		&--success {
			color: getColor(success);
		}
	}

	.notification {
		&__title {
			margin: 0;
			margin-top: 5px;
			margin-bottom: 5px;
			font-size: 16px;
		}

		&__notice {
			margin: 0;
			margin-bottom: 5px;
			font-size: 14px;
		}

		&__buttons {
			display: flex;
			margin-top: $gutter;
			padding-top: $gutter;
		}

		&__button {
			display: flex;
			align-items: center;
			appearance: none;
			border: 0;
			margin-top: $gutter;
			font-size: 14px;
			border-radius: 4px;
			color: getColor(primary);
			text-decoration: none;
			padding: $gutter $gutter * 2;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			background-color: transparentize(getColor(grey), 0.9);

			&:hover {
				cursor: pointer;
				background-color: transparentize(getColor(primary), 0.9);
				color: lighten(getColor(primary), 15);
			}

			&:active,

			&:focus {
				outline: 0;
			}
		}
	}
</style>
